import { readContract } from '@wagmi/core'
import { TokenABI } from 'primsell-shared-layer/core/contracts/abi/token'
import { nftERC5114Abi } from 'primsell-shared-layer/core/contracts/abi/nftERC5114Abi'
import Web3Service from 'primsell-shared-layer/core/services/web3'
import { Address } from 'viem'

const config = Web3Service.config

export class ContractReadService {
  async getLoyaltyBalanceOf<T>(...props: T[]): Promise<bigint | unknown> {
    const [contractAddress, ...rest] = props
    return await readContract(config, {
      address: contractAddress as Address,
      abi: nftERC5114Abi,
      functionName: 'balanceOf',
      //@ts-ignore
      args: [...rest],
    })
  }
  async getBalanceOf<T>(...props: T[]): Promise<bigint | unknown> {
    const [contractAddress, ...rest] = props
    return await readContract(config, {
      address: contractAddress as Address,
      abi: TokenABI,
      functionName: 'balanceOf',
      //@ts-ignore
      args: [...rest],
    })
  }
  async isApprovedForAll<T>(...props: T[]): Promise<bigint | unknown> {
    const [contractAddress, ...rest] = props
    return await readContract(config, {
      address: contractAddress as Address,
      abi: TokenABI,
      functionName: 'isApprovedForAll',
      //@ts-ignore
      args: [...rest],
    })
  }
}
